<template>
  <a-table
    row-key="id"
    size="middle"
    :columns="!isProgressive ? agentsTableColumns : agentsTableColumnsProgressive"
    :data-source="agents"
    :scroll="{ y: 324 }"
    :pagination="false"
  >
    <template #status="{ text, record }">
      <span class="state">
        <div
          class="state__indicator"
          :class="
            record.state !== StateOptions.Connected ? StateColor[record.state] : EventColor[text]
          "
        />
        {{ record.state !== StateOptions.Connected ? StateTexts[record.state] : EventTexts[text] }}
      </span>
    </template>

    <template #webphoneTitle>
      <WebphoneIcon />

      <a-tooltip>
        <template #title> Estado del webphone </template>

        <InfoCircleOutlined class="icon" />
      </a-tooltip>
    </template>

    <template #webphoneBody="{ text: status }">
      <a-tooltip>
        <template #title> {{ WebphoneText[status] }} </template>

        <a-tag :color="WebphoneColor[status]?.tag" class="webphone-tag">
          <WebphoneIcon :color="WebphoneColor[status]?.hexadecimal" />
        </a-tag>
      </a-tooltip>
    </template>

    <template #userProgressTitle>
      <div>
        Progreso
        <a-tooltip>
          <template #title>
            Indica cuántos contactos va gestionando el usuario, del total que se le fue asignado en la plantilla cargada.
          </template>

          <InfoCircleOutlined />
        </a-tooltip>
      </div>
    </template>

    <template #userProgressBody="{ text, record }">
      {{ `${record.total_managed} / ${record.total_assigned}` }}
    </template>
  </a-table>
</template>

<script setup>
import { InfoCircleOutlined } from "@ant-design/icons-vue";

import { agentsTableColumns, agentsTableColumnsProgressive } from "@/app/strategies/utils/constants";
import {
  WebphoneColor,
  WebphoneText,
  EventManagement,
  EventTexts,
  StateOptions,
  StateTexts,
} from "@/app/shared/utils/enums";

import WebphoneIcon from "@/app/shared/components/icons/WebphoneIcon.vue";

const EventColor = {
  [EventManagement.Online]: "connected-color",
  [EventManagement.Waiting]: "waiting-color",
  [EventManagement.Ringing]: "ringing-color",
  [EventManagement.Talking]: "talking-color",
  [EventManagement.Acw]: "acw-color",
  [EventManagement.Inactive]: "inactive-color",
};

const StateColor = {
  [StateOptions.Connected]: "connected-color",
  [StateOptions.Refreshment]: "refreshment-color",
  [StateOptions.Occupied]: "occupied-color",
  [StateOptions.Services]: "services-color",
  [StateOptions.Training]: "training-color",
  [StateOptions.Disconnected]: "disconnected-color",
  [StateOptions.NotAvailable]: "notAvailable-color",
  [StateOptions.Dinner]: "refreshment-color",
};

// const StateText = {
//   [EventManagement.Waiting]: "Esperando",
//   [EventManagement.Ringing]: "Timbrando",
//   [EventManagement.Talking]: "Hablando",
//   [EventManagement.Acw]: "ACW",
// };

defineProps({
  agents: {
    required: true,
    type: Array,
  },
  isProgressive: {
    required: false,
    type: Boolean,
    default: false,
  }
});
</script>

<style lang="sass" scoped>
:deep(.ant-table-align-center.ant-table-row-cell-break-word > .ant-table-header-column > div)
  height: 22px

.state
  display: inline-flex
  align-items: center

  &__indicator
    width: 8px
    height: 8px
    border-radius: 50%
    margin-right: 10px

  .waiting-color
    background-color: $cyan-4

  .ringing-color
    background-color: $blue-4

  .talking-color
    background-color: $green-4

  .acw-color
    background-color: $orange-4

  .connected-color
    background-color: $green-6

  .refreshment-color
    background-color: $gold-6

  .dinner-color
    background-color: $orange-6

  .occupied-color
    background-color: $red-6

  .services-color
    background-color: $blue-6

  .training-color
    background-color: $magenta-6

  .disconnected-color
    background-color: $gray-6

  .notAvailable-color
    background-color: $cyan-6

  .inactive-color
    background-color: $gray-6


.webphone-tag
  display: grid
  place-content: center
  width: 30px
  aspect-ratio: 1/1
  margin: 0 auto

.icon
  position: relative
  top: -4px
  left: 4px
</style>
